import { motion } from "framer-motion";
import { WHATSAPP_URL } from "@/data/social";
import { WhatsAppIcon } from "@/components/WhatsAppIcon";

export default function WhatsAppButton() {
    return (
        <motion.a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Chat with us on WhatsApp"
            data-testid="whatsapp-float-button"
            initial={{ opacity: 0, scale: 0.6, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            transition={{ delay: 1.2, duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
            whileHover={{ scale: 1.08 }}
            whileTap={{ scale: 0.95 }}
            className="group fixed bottom-5 right-5 z-50 flex items-center gap-3 rounded-full bg-[#25D366] py-3 pl-3 pr-3 text-white shadow-[0_10px_30px_-8px_rgba(37,211,102,0.7)] md:bottom-7 md:right-7 md:pr-5"
        >
            <span className="absolute inset-0 -z-10 animate-ping rounded-full bg-[#25D366]/40 [animation-duration:2.4s]" />
            <WhatsAppIcon className="h-6 w-6" />
            <span className="hidden text-sm font-bold tracking-tight md:inline">Chat on WhatsApp</span>
        </motion.a>
    );
}
